import { render, staticRenderFns } from "./bodyContent.vue?vue&type=template&id=53b573a6&lang=html&"
import script from "./bodyContent.vue?vue&type=script&lang=js&"
export * from "./bodyContent.vue?vue&type=script&lang=js&"
import style0 from "./bodyContent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports